export default __webpack_public_path__ + "static/media/Alberto Longo Elia.9f93d852.jpg";